export const LOGIN_API = "/login?app=admin";
export const REFRESH_TOKEN = "/token/refresh";
